require('./brokerMainStocksResultsList.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @helpers
const { formatText } = require('core/i18n').i18n;
// @commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { EmptyState } = require('commonsComponents/emptyState');
const { ContentBox } = require('commonsComponents/contentBox');
// @components
const BrokerMainStocksResultsListBox = require('components/broker/brokerMainStocksResultsListBox/brokerMainStocksResultsListBox');
// @constants
const { MYPROFILE_BROKER_EXPLORE_STOCKS_URL } = require('constants/index');

class BrokerMainStocksResultsList extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    buildErrorState() {
        const primaryText = formatText('broker-todaysMainStocksEmptyState');
        const secondaryText = formatText('broker-todaysMainStocksEmptyStateSecondary')
        const linkText = formatText('broker-mainStocksGoToSearch')
        return (
            <EmptyState
                secondaryText={secondaryText}
                primaryText={primaryText}
                linkText={linkText}
                linkURL={MYPROFILE_BROKER_EXPLORE_STOCKS_URL}
                iconType="nointernet-wealth" />
        );
    }

    buildLoadingSection() {
        const { immTodaysMainStocks } = this.props;

        if ( immTodaysMainStocks.get('isFetching') ){
            return (<LoadingSection />);
        }
    }

    handleRetry() {
        const {requestStocks, selectedMarket} = this.props;
        requestStocks(selectedMarket);
    }

    render() {
        const { selectedMarket, immTodaysMainStocks, hasControls, hasFilter, titlePrefix, selectedTab, immBrokerExchangeIndexes } = this.props;

        if (!immTodaysMainStocks || (!immTodaysMainStocks.get('isFetching') && !immTodaysMainStocks.get('hasBeenFetched') && !immTodaysMainStocks.get('error'))) {
            return null;
        }

        let content;

        if (immTodaysMainStocks.get('error')) {
            const errorContent = this.buildErrorState();
            content = (
                <ContentBox id="brokerMainStocksResultsList" customClassName="broker-main-stocks-results-list">
                    {errorContent}
                </ContentBox>
            );
        }

        if (immTodaysMainStocks.get('isFetching')) {
            content = (
                <ContentBox id="brokerMainStocksResultsList" customClassName="broker-main-stocks-results-list">
                    <LoadingSection />
                </ContentBox>
            );
        }

        if (immTodaysMainStocks.get('hasBeenFetched')) {
            content = (
                <BrokerMainStocksResultsListBox
                    immTodaysMainStocks={immTodaysMainStocks}
                    immBrokerExchangeIndexes={immBrokerExchangeIndexes}
                    selectedMarket={selectedMarket}
                    hasFilter={hasFilter}
                    hasControls={hasControls}
                    titlePrefix={titlePrefix}
                    selectedTab={selectedTab}
                />
            );
        }

        return content;
    }
}

BrokerMainStocksResultsList.propTypes = {
    immTodaysMainStocks: PropTypes.object.isRequired,
    selectedMarket: PropTypes.string,
    requestStocks: PropTypes.func.isRequired,
    titlePrefix: PropTypes.string,
    hasControls: PropTypes.bool,
    hasFilter: PropTypes.bool,
    selectedTab: PropTypes.number,
    immBrokerExchangeIndexes: PropTypes.object.isRequired,
};

BrokerMainStocksResultsList.defaultProps = {
    hasControls: true,
    hasFilter: false
}

module.exports = BrokerMainStocksResultsList;
